<lbca-message-feedback
	[show]="messageFeedbackService.messageFeedObject.show"
	[type]="messageFeedbackService.messageFeedObject.type"
	[autoclose]="messageFeedbackService.messageFeedObject.autoclose"
	(closeFeed)="messageFeedbackService.closeFeed()"
	[emoji]="messageFeedbackService.messageFeedObject.emoji"
>
	<li messagePrimary>{{ messageFeedbackService.messageFeedObject.primary }}</li>
	<li messageSecondary>{{ messageFeedbackService.messageFeedObject.secondary }}</li>
</lbca-message-feedback>

<main>
	<!-- Cabeçalho -->
	<section class="inline-flex w-full mb-[40px]">
		<lbca-icon
			name="lucide:move-left"
			class="text-primary mt-[15px] mr-[15px]"
			(click)="actionBackRegister($event)"
		></lbca-icon>

		<div class="w-[60%]"></div>
		<!-- <div class="flex flex-col">
    <div class="text-xs text-font ml-[25px]" *ngIf="currentLegalRequest?.label">{{claimLabelsDict['actual-phase']}}</div>
  </div> -->
	</section>

	<!-- first step -->
	@if (currentStepIndex === 0) {
		<section class="form-fields-sub-module-modal">
			<div class="ff-row-form overflow-x-hidden mt-[44px] mb-[44px]">
				<div class="ff-col-form overflow-x-hidden">
					<div class="ff-box-field ff-field-size-3">
						<lbca-date-picker
							[label]="config?.dateReference.label"
							[disabled]="false"
							[labeled]="true"
							[require]="config.dateReference.required"
							[rules]="config.dateReference.rules"
							[disabledDateRules]="config.dateReference.disabledDateRules"
							(changeValue)="changeValue($event, ['dateReference'], callCalc)"
							[error]="formData?.dateReference?.error"
							[value]="formData?.dateReference?.value || ''"
						></lbca-date-picker>
					</div>
				</div>
			</div>
			<div class="ff-col-form overflow-x-hidden">
				<div class="ff-box-field ff-field-size-7">
					<lbca-select-tree
						[field]="config.typeId"
						[label]="config.typeId.label"
						[require]="config.typeId.required"
						[error]="formData.typeId.error"
						[value]="formData.typeId.value"
						[disabled]="false"
						[cardData]="cardInfo"
						(changeValue)="changeValue($event, ['typeId'])"
					></lbca-select-tree>
				</div>
			</div>
		</section>
	}

	<!-- second step (pay step) -->
	@if (formSteps[currentStepIndex].stepName === 'payFields') {
		<section class="form-fields-sub-module-modal">
			<!-- values visualization wrap -->
			<div class="flex flex-row justify-between flex-wrap items-center mb-[64px] w-full">
				<div class="justify-center flex flex-col">
					<lbca-input-text
						[maskInput]="'CURRENCY_BR'"
						[labeled]="false"
						[componetHelperIconLeftStyle]="'total-inicial-light-white'"
						[copyContent]="false"
						label="Total Inicial"
						[loadingState]="totalValue.loading"
						[value]="totalValue.value"
					></lbca-input-text>
				</div>
				<div class="justify-center flex flex-col">
					<lbca-input-text
						[maskInput]="'CURRENCY_BR'"
						[componetHelperIconLeftStyle]="'total-atualizado-light-white'"
						[labeled]="false"
						[copyContent]="false"
						label="Total Atualizado"
						[loadingState]="totalValueCorrectBalance.loading"
						[value]="totalValueCorrectBalance.value"
					></lbca-input-text>
				</div>
				<div class="justify-center flex flex-col">
					<lbca-input-text
						[maskInput]="'CURRENCY_BR'"
						[componetHelperIconLeftStyle]="'risco-light-white'"
						[labeled]="false"
						[copyContent]="false"
						label="Total Risco Envolvido"
						[loadingState]="totalRiskCalculate.loading"
						[value]="totalRiskCalculate.value"
					></lbca-input-text>
				</div>
			</div>
			<!-- pay fields, need refactor -->
			<ng-container>
				<ng-template [ngTemplateOutlet]="payFields"></ng-template>
			</ng-container>
		</section>
	}

	<!-- third step -->
	@if (formSteps[currentStepIndex].stepName === 'emailFields') {
		<section class="form-fields-sub-module-modal">
			<ng-container>
				<ng-template [ngTemplateOutlet]="emailFields"></ng-template>
			</ng-container>
		</section>
	}

	@if (formSteps[currentStepIndex].stepName === 'ipFields') {
		<section class="form-fields-sub-module-modal">
			<ng-container>
				<ng-template [ngTemplateOutlet]="ipFields"></ng-template>
			</ng-container>
		</section>
	}

	@if (formSteps[currentStepIndex].stepName === 'urlFields') {
		<section class="form-fields-sub-module-modal">
			<ng-container>
				<ng-template [ngTemplateOutlet]="urlFields"></ng-template>
			</ng-container>
		</section>
	}

	@if (formSteps[currentStepIndex].stepName === 'imeiFields') {
		<section class="form-fields-sub-module-modal">
			<ng-container>
				<ng-template [ngTemplateOutlet]="imeiFields"></ng-template>
			</ng-container>
		</section>
	}

	@if (formSteps[currentStepIndex].stepName === 'accountIdFields') {
		<section class="form-fields-sub-module-modal">
			<ng-container>
				<ng-template [ngTemplateOutlet]="accountIdFields"></ng-template>
			</ng-container>
		</section>
	}

	<!-- action buttons wrapper -->
	<section class="claim-bottom-modal-container">
		<ng-template [ngTemplateOutlet]="actionsControllers"></ng-template>

		<div class="flex">
			@if (currentStepIndex === 0) {
				<button type="button" class="btn-secondary btn-type-2 ml-[4px]" (click)="closeModal()">
					Cancelar
				</button>
			}
			@if (currentStepIndex > 0) {
				<button type="button" class="btn-secondary btn-type-2 ml-[4px]" (click)="goToBackStep()">
					Voltar
				</button>
			}
			@if (formSteps.length > currentStepIndex + 1) {
				<button
					type="button"
					class="btn-primary btn-type-2 ml-[25px]"
					(click)="goToNextStep(formSteps[currentStepIndex])"
				>
					Continuar
				</button>
			}
			@if (formSteps.length === currentStepIndex + 1) {
				<button
					type="button"
					[class.pointer-events-none]="loadingSubmit"
					class="btn-primary btn-type-2 ml-[25px]"
					(click)="submitLegalRequestForm(formSteps[currentStepIndex])"
				>
					@if (loadingSubmit) {
						<img class="forgot-loading" src="./assets/icons/loading-points.svg" />
					}
					@if (!loadingSubmit) {
						Cadastrar Pedido
					}
				</button>
			}
		</div>
	</section>
</main>

<ng-template #actionsControllers>
	<section class="controlers-action">
		<!-- (click)="goToStep(idx)"  -->
		@for (step of formSteps; track step; let idx = $index) {
			<div
				[class.active]="idx === currentStepIndex"
				class="btn-prevnext"
				[class.disabled]="!step.isTouched || step.hasError"
			></div>
		}
	</section>
</ng-template>

<ng-template #payFields>
	@if (formControl.hasPrimary.visible) {
		<div class="flex w-full">
			<div class="inline-flex items-center mb-[12px]">
				<p class="text-font text-xs">Principal</p>
			</div>
		</div>
	}

	<div class="ff-row-form overflow-x-hidden w-full">
		@if (!simple) {
			<div class="ff-row-form overflow-x-hidden">
				<div class="ff-box-field ff-field-size-3">
					@if (extraFields?.typeExchangeRate) {
						<lbca-entity-fields
							forceType="SELECT_ONE"
							[inline]="true"
							[field]="extraFields.typeExchangeRate"
							[label]="extraFields.typeExchangeRate?.label"
							[disabled]="false"
							[labeled]="true"
							[require]="extraFields.typeExchangeRate?.required"
							[cardData]="cardInfo"
							[error]="formData?.typeExchangeRate?.error"
							[value]="formData?.typeExchangeRate?.value || ''"
							(changeValue)="changeValue($event, ['typeExchangeRate'], callCalc)"
						></lbca-entity-fields>
					}
				</div>
				@if (formControl.dolarQuotation?.visible && extraFields?.dolarQuotation) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-input-text
							[label]="extraFields.dolarQuotation?.label"
							[disabled]="false"
							[labeled]="true"
							[require]="extraFields.dolarQuotation?.required"
							[maskInput]="extraFields.dolarQuotation.mask"
							[error]="formData?.dolarQuotation?.error"
							[value]="formData?.dolarQuotation?.value || ''"
							(changeValue)="changeValue($event, ['dolarQuotation'], callCalc)"
						></lbca-input-text>
					</div>
				}
				@if (formControl.primaryValueUS?.visible && extraFields?.primaryValueUS) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-input-text
							[label]="extraFields.primaryValueUS?.label"
							[disabled]="false"
							[labeled]="true"
							[require]="extraFields.primaryValueUS?.required"
							[maskInput]="extraFields.primaryValueUS.mask"
							[error]="formData?.primaryValueUS?.error"
							[value]="formData?.primaryValueUS?.value || ''"
							(changeValue)="changeValue($event, ['primaryValueUS'], callCalc)"
						></lbca-input-text>
					</div>
				}
				@if (extraFields?.primaryValue) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-input-text
							[label]="extraFields.primaryValue?.label"
							[disabled]="formControl.primaryValue?.disabled"
							[labeled]="true"
							[require]="extraFields.primaryValue?.required"
							[maskInput]="extraFields.primaryValue.mask"
							[error]="formData?.primaryValue?.error"
							[value]="formData?.primaryValue?.value || ''"
							(changeValue)="changeValue($event, ['primaryValue'], callCalc)"
						></lbca-input-text>
					</div>
				}
				@if (extraFields?.endValue) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-input-text
							[label]="extraFields.endValue?.label"
							[disabled]="false"
							[labeled]="true"
							[require]="extraFields.endValue?.required"
							[maskInput]="extraFields.endValue.mask"
							[error]="formData?.endValue?.error"
							[value]="formData?.endValue?.value || ''"
							(changeValue)="changeValue($event, ['endValue'], callCalc)"
						></lbca-input-text>
					</div>
				}
				@if (extraFields?.primaryIndexId) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-entity-fields
							forceType="SELECT_ONE"
							[inline]="true"
							[field]="extraFields.primaryIndexId"
							[label]="extraFields.primaryIndexId?.label"
							[disabled]="false"
							[labeled]="true"
							[require]="extraFields.primaryIndexId?.required"
							[cardData]="cardInfo"
							[error]="formData?.primaryIndexId?.error"
							[value]="formData?.primaryIndexId?.value || ''"
							(changeValue)="changeValue($event, ['primaryIndexId'], callCalc)"
						></lbca-entity-fields>
					</div>
				}
				@if (extraFields?.financialCode) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-input-text
							[label]="extraFields.financialCode?.label"
							[disabled]="false"
							[labeled]="true"
							[require]="extraFields.financialCode?.required"
							[error]="formData?.financialCode?.error"
							[value]="formData?.financialCode?.value || ''"
							(changeValue)="changeValue($event, ['financialCode'], callCalc)"
						></lbca-input-text>
					</div>
				}
				<ng-container>
					<ng-template [ngTemplateOutlet]="controllers"></ng-template>
				</ng-container>
			</div>
		}

		@if (simple) {
			<div class="ff-row-form overflow-x-hidden">
				<div class="ff-box-field ff-field-size-3">
					<lbca-input-text
						[label]="extraFields.primaryValue?.label"
						[disabled]="formControl.primaryValue?.disabled"
						[labeled]="true"
						[require]="extraFields.primaryValue?.required"
						[maskInput]="extraFields.primaryValue.mask"
						[error]="formData?.primaryValue?.error"
						[value]="formData?.primaryValue?.value || ''"
						(changeValue)="changeValue($event, ['primaryValue'], callCalc)"
					></lbca-input-text>
				</div>
			</div>
		}
	</div>

	@if (formControl.hasInterest.visible) {
		<div class="flex w-full">
			<div class="inline-flex items-center mb-[12px]">
				<p class="text-font text-xs">Juros</p>
			</div>
		</div>
		<div class="ff-row-form overflow-x-hidden w-full">
			<div class="ff-row-form overflow-x-hidden">
				<div class="ff-box-field ff-field-size-3">
					<lbca-entity-fields
						forceType="RADIO"
						[inline]="true"
						[field]="extraFields.interestType"
						[label]="extraFields.interestType?.label"
						[disabled]="false"
						[labeled]="true"
						[require]="extraFields.interestType?.required"
						[cardData]="cardInfo"
						[error]="formData?.interestType?.error"
						[value]="formData?.interestType?.value || ''"
						(changeValue)="changeValue($event, ['interestType'], callCalc)"
					></lbca-entity-fields>
				</div>
				<div class="ff-box-field ff-field-size-3">
					<lbca-date-picker
						[label]="extraFields.interestDateReference.label"
						[disabled]="false"
						[labeled]="true"
						[require]="extraFields.interestDateReference.required"
						[calendarPosition]="'top'"
						[rules]="extraFields.interestDateReference.rules"
						[disabledDateRules]="extraFields.interestDateReference.disabledDateRules"
						(changeValue)="changeValue($event, ['interestDateReference'], callCalc)"
						[error]="formData?.interestDateReference?.error"
						[value]="formData?.interestDateReference?.value || ''"
					></lbca-date-picker>
				</div>
				<div class="ff-box-field ff-field-size-3">
					<lbca-input-text
						[label]="extraFields.interestPercents?.label"
						[disabled]="formControl.interestPercents.disabled"
						[labeled]="true"
						[require]="extraFields.interestPercents?.required"
						[maskInput]="extraFields.interestPercents.mask"
						[error]="formData?.interestPercents?.error"
						[value]="formData?.interestPercents?.value || ''"
						(changeValue)="changeValue($event, ['interestPercents'], callCalc)"
					></lbca-input-text>
				</div>
			</div>
			<div class="ff-box-field ff-field-size-1 flex items-center">
				<label (click)="toogle(['hasInterest'])" class="claim-trash-container">
					<div class="claim-trash"></div>
				</label>
			</div>
		</div>
	}

	@if (formControl.hasPenalty.visible) {
		<div class="flex w-full">
			<div class="inline-flex items-center mb-[12px]">
				<p class="text-font text-xs">Multa</p>
			</div>
		</div>
		<div class="ff-row-form overflow-x-hidden w-full">
			<div class="ff-box-field ff-field-size-3">
				<lbca-input-text
					[label]="extraFields.penaltyPercents?.label"
					[disabled]="false"
					[labeled]="true"
					[require]="extraFields.penaltyPercents?.required"
					[maskInput]="extraFields.penaltyPercents.mask"
					[error]="formData?.penaltyPercents?.error"
					[value]="formData?.penaltyPercents?.value || ''"
					(changeValue)="changeValue($event, ['penaltyPercents'], callCalc)"
				></lbca-input-text>
			</div>
			<div class="ff-box-field ff-field-size-1 flex items-center">
				<label (click)="toogle(['hasPenalty'])" class="claim-trash-container">
					<div class="claim-trash"></div>
				</label>
			</div>
		</div>
	}
</ng-template>

<ng-template #controllers>
	<div class="ff-box-field ff-field-size-1 flex justify-between items-center w-full">
		@if (!formControl.hasInterest.visible) {
			<div class="flex flex-row items-center">
				<label
					(click)="toogle(['hasInterest'])"
					class="shadow cursor-pointer rounded-full flex items-center justify-center p-[0px] h-[24px] w-6 min-w-6 text-2xl text-gray-50 transition duration-400 ease-in-out"
					[class.bg-primary]="!formControl.hasInterest.disabled"
					[class.bg-gray-600]="formControl.hasInterest.disabled"
					[class.cursor-not-allowed]="formControl.hasInterest.disabled"
				>
					<svg
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 5V0.666667C5.11111 0.444444 5.33333 0 6 0C6.66667 0 6.88889 0.444444 7 0.666667V5H11.3333C11.5556 5.11111 12 5.46667 12 6C12 6.53333 11.5556 6.88889 11.3333 7H7V11.3333C7 11.3333 6.66667 12 6 12C5.33333 12 5 11.3333 5 11.3333V7H0.666667C0.666667 7 0 6.66667 0 6C0 5.33333 0.666667 5 0.666667 5H5Z"
							fill="white"
						/>
					</svg>
				</label>
				<span
					class="text-sm text-gray-700 ml-[5px]"
					[class.cursor-pointer]="!formControl.hasInterest.disabled"
					[class.cursor-not-allowed]="formControl.hasInterest.disabled"
					(click)="toogle(['hasInterest'])"
				>
					Juros
				</span>
			</div>
		}

		@if (!formControl.hasPenalty.visible) {
			<div class="flex flex-row items-center">
				<label
					(click)="toogle(['hasPenalty'])"
					class="shadow cursor-pointer rounded-full flex items-center justify-center p-[0px] h-[24px] w-6 min-w-6 text-2xl text-gray-50 transition duration-400 ease-in-out"
					[class.bg-primary]="!formControl.hasPenalty.disabled"
					[class.bg-gray-600]="formControl.hasPenalty.disabled"
					[class.cursor-not-allowed]="formControl.hasPenalty.disabled"
				>
					<svg
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 5V0.666667C5.11111 0.444444 5.33333 0 6 0C6.66667 0 6.88889 0.444444 7 0.666667V5H11.3333C11.5556 5.11111 12 5.46667 12 6C12 6.53333 11.5556 6.88889 11.3333 7H7V11.3333C7 11.3333 6.66667 12 6 12C5.33333 12 5 11.3333 5 11.3333V7H0.666667C0.666667 7 0 6.66667 0 6C0 5.33333 0.666667 5 0.666667 5H5Z"
							fill="white"
						/>
					</svg>
				</label>
				<span
					class="text-sm text-gray-700 ml-[5px]"
					[class.cursor-pointer]="!formControl.hasPenalty.disabled"
					[class.cursor-not-allowed]="formControl.hasPenalty.disabled"
					(click)="toogle(['hasPenalty'])"
				>
					Multa
				</span>
			</div>
		}
	</div>
</ng-template>

<ng-template #emailFields>
	<div class="flex w-full">
		<div class="inline-flex items-center mb-[12px]">
			<p class="text-font text-xs">Email</p>
		</div>
	</div>

	<div class="ff-row-form overflow-x-hidden w-full">
		<div class="ff-row-form overflow-x-hidden">
			<ng-container>
				<div class="ff-box-field ff-field-size-7">
					<lbca-gridbox-unique
						[field]="config.emailList"
						[configuration]="config.emailList.configuration"
						[label]="config.emailList.label"
						[require]="config.emailList.required"
						[cardData]="cardInfo"
						[labeled]="true"
						[helperText]="config.emailList.helperText"
						[disabled]="false"
						(changeValue)="changeValue($event, ['emailList'])"
						[enableLogicalDeletion]="true"
						[error]="formData?.emailList && formData?.emailList?.error"
						[value]="(formData?.emailList && formData?.emailList?.value) || ''"
					></lbca-gridbox-unique>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #ipFields>
	<div class="flex w-full">
		<div class="inline-flex items-center mb-[12px]">
			<p class="text-font text-xs">IP</p>
		</div>
	</div>

	<div class="ff-row-form overflow-x-hidden w-full">
		<div class="ff-row-form overflow-x-hidden">
			<ng-container>
				<div class="ff-box-field ff-field-size-7">
					<lbca-gridbox-unique
						[field]="config.ipList"
						[configuration]="config.ipList.configuration"
						[label]="config.ipList.label"
						[require]="config.ipList.required"
						[cardData]="cardInfo"
						[labeled]="true"
						[helperText]="config.ipList.helperText"
						[disabled]="false"
						(changeValue)="changeValue($event, ['ipList'])"
						[enableLogicalDeletion]="true"
						[error]="formData?.ipList && formData?.ipList?.error"
						[value]="(formData?.ipList && formData?.ipList?.value) || ''"
					></lbca-gridbox-unique>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #urlFields>
	<div class="flex w-full">
		<div class="inline-flex items-center mb-[12px]">
			<p class="text-font text-xs">URL's</p>
		</div>
	</div>

	<div class="ff-row-form overflow-x-hidden w-full">
		<div class="ff-row-form overflow-x-hidden">
			<ng-container>
				<div class="ff-box-field ff-field-size-7">
					<lbca-gridbox-unique
						[field]="config.urlList"
						[configuration]="config.urlList.configuration"
						[label]="config.urlList.label"
						[require]="config.urlList.required"
						[cardData]="cardInfo"
						[labeled]="true"
						[helperText]="config.urlList.helperText"
						[disabled]="false"
						(changeValue)="changeValue($event, ['urlList'])"
						[enableLogicalDeletion]="true"
						[error]="formData?.urlList && formData?.urlList?.error"
						[value]="(formData?.urlList && formData?.urlList?.value) || ''"
					></lbca-gridbox-unique>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #imeiFields>
	<div class="flex w-full">
		<div class="inline-flex items-center mb-[12px]">
			<p class="text-font text-xs">IMEI's</p>
		</div>
	</div>

	<div class="ff-row-form overflow-x-hidden w-full">
		<div class="ff-row-form overflow-x-hidden">
			<ng-container>
				<div class="ff-box-field ff-field-size-7">
					<lbca-gridbox-unique
						[field]="config.imeiList"
						[configuration]="config.imeiList.configuration"
						[label]="config.imeiList.label"
						[require]="config.imeiList.required"
						[cardData]="cardInfo"
						[labeled]="true"
						[helperText]="config.imeiList.helperText"
						[disabled]="false"
						(changeValue)="changeValue($event, ['imeiList'])"
						[error]="formData?.imeiList && formData?.imeiList?.error"
						[enableLogicalDeletion]="true"
						[value]="(formData?.imeiList && formData?.imeiList?.value) || ''"
					></lbca-gridbox-unique>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #accountIdFields>
	<div class="flex w-full">
		<div class="inline-flex items-center mb-[12px]">
			<p class="text-font text-xs">ID's conta ADS/Workspace</p>
		</div>
	</div>

	<div class="ff-row-form overflow-x-hidden w-full">
		<div class="ff-row-form overflow-x-hidden">
			<ng-container>
				<div class="ff-box-field ff-field-size-7">
					<lbca-gridbox-unique
						[field]="config.accountIdList"
						[configuration]="config.accountIdList.configuration"
						[label]="config.accountIdList.label"
						[require]="config.accountIdList.required"
						[cardData]="cardInfo"
						[labeled]="true"
						[helperText]="config.accountIdList.helperText"
						[disabled]="false"
						(changeValue)="changeValue($event, ['accountIdList'])"
						[enableLogicalDeletion]="true"
						[error]="formData?.accountIdList && formData?.accountIdList?.error"
						[value]="(formData?.accountIdList && formData?.accountIdList?.value) || ''"
					></lbca-gridbox-unique>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template #templateLegalRequestCreated>
	<div class="text-base text-font flex items-center justify-center show">
		Pedido cadastrado
		<div class="emojis-glasses icon-box ml-[16px]"></div>
	</div>
</ng-template>
